import {NgModule} from '@angular/core';
import {MeasurementsService} from './measurements.service';
import {SharedProviderModule} from '../shared/shared.module';
import {MeasurementsLiveComponent} from './measurements-live/measurements-live.component';
import {NgxChartsModule} from '@mipro/ngx-charts';
import {OverlayPanelModule} from '../components/overlay-panel/overlay-panel.module';
import {LinkingService} from '../linking/linking.service';
import {ElementUtilsModule} from '../element-utils/element-utils.module';
import { NgbNavModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { MeasurementsTableComponent } from './measurements-table/measurements-table.component';
import { NeveMeasurementsModule } from '~app/custom/neve/measurements/neve-measurements.module';
import { NeveModule } from '~app/custom/neve/neve.module';
import { InfluxModule } from '~app/influx/influx.module';

@NgModule({
  imports: [
    ElementUtilsModule,
    OverlayPanelModule,
    NgxChartsModule,
    NgbDatepickerModule,
    NgbNavModule,
    SharedProviderModule,
    NeveMeasurementsModule,
    NeveModule,
    InfluxModule,
  ],
  declarations: [MeasurementsLiveComponent, MeasurementsTableComponent],
  exports: [MeasurementsLiveComponent, MeasurementsTableComponent],
  providers: [MeasurementsService, LinkingService]
})
export class MeasurementsModule {
}
